import { render, staticRenderFns } from "./SignPage.vue?vue&type=template&id=0c640b49&scoped=true"
import script from "./SignPage.vue?vue&type=script&lang=js"
export * from "./SignPage.vue?vue&type=script&lang=js"
import style0 from "./SignPage.vue?vue&type=style&index=0&id=0c640b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c640b49",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QSpace,QInnerLoading,QSpinner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QSpace,QInnerLoading,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
